interface RodapePassosProps {
  passo: number;
  total: number;
  salvando: boolean;
  salvo: boolean;
  /** Quantas pendências bloqueiam o Publicar (0 = pode publicar). */
  faltam?: number;
  aoVoltar: () => void;
  aoContinuar: () => void;
  aoSalvarRascunho: () => void;
}

export default function RodapePassos({
  passo,
  total,
  salvando,
  salvo,
  faltam = 0,
  aoVoltar,
  aoContinuar,
  aoSalvarRascunho,
}: RodapePassosProps) {
  const ultimo = passo === total;
  const travado = ultimo && faltam > 0;

  return (
    <div className="fixed inset-x-0 bottom-0 z-20 border-t border-secondary-200 bg-white px-4 py-3">
      <div className="mx-auto w-full max-w-[720px]">
        {(salvando || salvo) && (
          <div className="mb-2 flex items-center gap-1.5 text-xs text-secondary-500">
            {salvando ? (
              'Salvando…'
            ) : (
              <>
                <i className="ri-check-line" />
                Salvo
              </>
            )}
          </div>
        )}
        <div className="flex items-center gap-3">
          {ultimo ? (
            <button
              type="button"
              onClick={aoSalvarRascunho}
              disabled={salvando}
              className="cursor-pointer whitespace-nowrap rounded-md px-4 py-3 text-[15px] font-medium text-secondary-600 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-50"
            >
              Salvar como rascunho
            </button>
          ) : (
            passo > 1 && (
              <button
                type="button"
                onClick={aoVoltar}
                disabled={salvando}
                className="cursor-pointer whitespace-nowrap rounded-md px-4 py-3 text-[15px] font-medium text-secondary-600 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-50"
              >
                Voltar
              </button>
            )
          )}
          <button
            type="button"
            onClick={aoContinuar}
            disabled={salvando || travado}
            className="flex h-12 flex-1 cursor-pointer items-center justify-center whitespace-nowrap rounded-md bg-primary-500 text-[15px] font-medium text-white transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:bg-secondary-200 disabled:text-secondary-400"
          >
            {ultimo ? 'Publicar evento' : 'Continuar'}
          </button>
        </div>
        {travado && !salvando && (
          <p className="mt-2 text-center text-sm text-foreground-700">
            Falta {faltam} {faltam === 1 ? 'coisa' : 'coisas'} para colocar no ar.
          </p>
        )}
      </div>
    </div>
  );
}